
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Accordion } from "@/components/ui/accordion";
import { NavItem } from "./NavItem";
import { NavItemType, navItems } from "./navItems";

interface SidebarNavigationProps {
  expanded: boolean;
  closeSidebar: () => void;
}

export const SidebarNavigation = ({ expanded, closeSidebar }: SidebarNavigationProps) => {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>({});
  
  const toggleAccordionItem = (itemTitle: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemTitle]: !prev[itemTitle]
    }));
  };

  // Check if the current route matches any nav item or its children
  const isActiveRoute = (item: NavItemType): boolean => {
    const pathname = location.pathname;
    
    if (pathname === item.href) {
      return true;
    }
    
    // Check children routes
    if (item.children && item.children.length > 0) {
      return item.children.some(child => pathname === child.href);
    }
    
    return false;
  };

  return (
    <div className="flex-1 overflow-y-auto py-4">
      <Accordion type="multiple" defaultValue={[]} className="space-y-1">
        {navItems.map((item: NavItemType) => (
          <NavItem
            key={item.title}
            {...item}
            isActive={isActiveRoute(item)}
            closeSidebar={closeSidebar}
            toggleAccordionItem={toggleAccordionItem}
            showLabels={expanded}
          />
        ))}
      </Accordion>
    </div>
  );
};
